const uniq = (array) => Array.from(new Set(array).values());

const flattenArray = (arrays) => [].concat(...arrays);

const flatMap = (arr, fn) => flattenArray(arr.map(fn));

const arrayToHashmap = (array) => (
    Object.assign({}, ...array.map(([key, val]) => ({ [key]: val })))
);

module.exports = {
    uniq,
    flattenArray,
    flatMap,
    arrayToHashmap
};
